<template>
<div class="chapter">
<div class="inner_page">
<p class="center2"><span><a id="page_v"><i>To the coaches and athletes of CrossFit Elysium,<br/>for their friendship and constant inspiration</i></a></span></p><a id="page_v">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter01.vue?2d9f84ca